import React from 'react';
import ListingForm from './ListingForm';

const ListingModal = ({ open, onClose, initialListing, initialType, onSaved }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-start justify-center overflow-y-auto bg-black/70 px-2 py-2 sm:px-4 sm:py-6">
      <div className="w-full max-w-[1200px]">
        <ListingForm
          initialListing={initialListing}
          initialType={initialType}
          onSaved={onSaved}
          onCancel={onClose}
          compact
        />
      </div>
    </div>
  );
};

export default ListingModal;
